import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LoginAuthenticationScreenModule } from './features/login-modal/login-authentication-screen/login-authentication-screen.module';

@NgModule({
  imports: [CommonModule, LoginAuthenticationScreenModule],
  declarations: [],
  exports: [LoginAuthenticationScreenModule]
})
export class UiModule {}
